<div class="wrapper">
    <div class="header">
        <app-section-header [title]="'Opportunities'" [iconName]="'opportunities'" [actionsTemplate]="actionsTemplate">
            <ng-template #actionsTemplate>
                <div class="actions">
                    <button class="primary-btn" (click)="onCreateNewOpportunityClicked()">
                        <span class="icon" [innerHTML]="plusIcon"></span> New Opportunity
                    </button>
                </div>
            </ng-template>
        </app-section-header>

        <div class="filters">
            <app-opportunities-filters [currentTab]="currentTab" filtersKey="opportunities"></app-opportunities-filters>
            @if (currentTab === 'List') {
                <app-column-visibility [entityType]="entityTypeId"></app-column-visibility>
            }
        </div>
    </div>
    <div class="tabGroup">
        <lib-tab-view [(currentTab)]="currentTab" [hasSteps]="false" [alignment]="'end'">
            <lib-tab-item tabName="List" [bodyTemplate]="list" [icon]="listIcon">
                <ng-template #list>
                    <div class="tab">
                        <app-opportunities-list filtersKey="opportunities"></app-opportunities-list>
                    </div>
                </ng-template>
            </lib-tab-item>
            <lib-tab-item tabName="Calendar" [bodyTemplate]="calendar" [icon]="calendarIcon">
                <ng-template #calendar>
                    <div class="tab">
                        <app-opportunities-calendar></app-opportunities-calendar>
                    </div>
                </ng-template>
            </lib-tab-item>

            <lib-tab-item tabName="Map" [bodyTemplate]="map" [icon]="mapIcon">
                <ng-template #map>
                    <div class="tab">
                        <app-opportunities-map></app-opportunities-map>
                    </div>
                </ng-template>
            </lib-tab-item>
        </lib-tab-view>
    </div>
</div>
